<template>
  <div :class="readOnly?'readonly_panel':''">
    <el-upload
      :action="uploadUrl"
      :before-upload="handleBeforeUpload"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      name="file"
      :show-file-list="false"
      :headers="headers"
      style="display: none"
      ref="upload"
    >
    </el-upload>
    <!-- if只读的话，只显示外部引用dom -->
    <div :id="`toolbar${toolbarId}`" class="readonly_toolbar" v-if="readOnly"></div>
    <div :id="`toolbar${toolbarId}`" v-else>
      <!-- 添加粗体按钮 -->
      <button class="ql-bold"></button>
      <!-- 添加斜体按钮 -->
      <button class="ql-italic"></button>
      <!-- 添加下划线按钮 -->
      <button class="ql-underline"></button>
      <!-- 添加删除线按钮 -->
      <button class="ql-strike"></button>
      <!-- 添加引用按钮 -->
      <button class="ql-blockquote"></button>
      <!-- 添加代码块按钮 -->
      <button class="ql-code-block"></button>
      <!-- 添加有序列表按钮 -->
      <button class="ql-list" value="ordered"></button>
      <!-- 添加无序列表按钮 -->
      <button class="ql-list" value="bullet"></button>
      <!-- 添加无序列表按钮 -->
      <button class="ql-indent" value="-1"></button>
      <!-- 添加无序列表按钮 -->
      <button class="ql-indent" value="+1"></button>
      <!-- 添加字体大小下拉列表 -->
      <select class="ql-size">
        <option value="small"></option>
        <!-- 注意，缺少falsy值，用于重置为默认值 -->
        <option selected></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
      <!-- 添加标题下拉列表 -->
      <select class="ql-header">
        <option value="1"></option>
        <option value="2"></option>
        <option value="3"></option>
        <option value="4"></option>
        <option value="5"></option>
        <option value="6"></option>
        <option selected></option>
      </select>
      <!-- 添加颜色选择列表 -->
      <select class="ql-color">
      </select>
      <!-- 添加背景色选择列表 -->
      <select class="ql-background">
      </select>
      <!-- 添加对齐方式列表 -->
      <select class="ql-align">
      </select>
      <!-- 添加清除文本格式按钮 -->
      <button class="ql-clean"></button>
      <!-- 添加链接、图片、视频按钮 -->
      <button class="ql-link"></button>
      <button class="ql-image"></button>
      <button class="ql-video"></button>
      <!-- 添加字体下拉列表 -->
      <!-- <select class="ql-font">
      </select> -->
      <!-- 添加下标和上标按钮 -->
      <!-- <button class="ql-script" value="sub"></button>
      <button class="ql-script" value="super"></button> -->
      <!-- 添加无序列表按钮 -->
      <!-- <button class="ql-direction" value="rtl"></button> -->
      <!-- 代码转换按钮 -->
      <button class="ql-html" :class="isHtmlReverse?'active':''" @click="htmlReverse">html</button>
    </div>
    <div class="editor" ref="editor" :style="styles"></div>
  </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Cookies from 'js-cookie'
import axios from 'axios'
import * as userApi from '@/api/adminApi/zh/user';
export default {
  name: "Editor",
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: "",
    },
    /* 高度 */
    height: {
      type: Number,
      default: null,
    },
    /* 最小高度 */
    minHeight: {
      type: Number,
      default: null,
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false,
    },
    // 上传文件大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    /* 类型（base64格式、url格式） */
    type: {
      type: String,
      default: "url",
    }
  },
  data() {
    return {
      toolbarId: null,
      uploadUrl: "/file/upload", // 上传的图片服务器地址
      headers: {
        token: this.getToken()
      },
      Quill: null,
      currentValue: "",
      options: {
        theme: "snow",
        bounds: document.body,
        debug: "warn",
        modules: {
          // // 工具栏配置
          // toolbar: [
          //   ["bold", "italic", "underline", "strike"],       // 加粗 斜体 下划线 删除线
          //   ["blockquote", "code-block"],                    // 引用  代码块
          //   [{ list: "ordered" }, { list: "bullet" }],       // 有序、无序列表
          //   [{ indent: "-1" }, { indent: "+1" }],            // 缩进
          //   [{ size: ["small", false, "large", "huge"] }],   // 字体大小
          //   [{ header: [1, 2, 3, 4, 5, 6, false] }],         // 标题
          //   [{ color: [] }, { background: [] }],             // 字体颜色、字体背景颜色
          //   [{ align: [] }],                                 // 对齐方式
          //   ["clean"],                                       // 清除文本格式
          //   ["link", 'image', "video"]                       // 链接、图片、视频
          // ],
          toolbar: `#toolbar${this.toolbarId}`
        },
        placeholder: "请输入内容",
        readOnly: this.readOnly
      },
      isHtmlReverse: false, // 是否转换为html
    };
  },
  computed: {
    styles() {
      let style = {};
      if (this.minHeight) {
        style.minHeight = `${this.minHeight}px`;
      }
      if (this.height) {
        style.height = `${this.height}px`;
      }
      return style;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.chechHtmlReverseStatus(val);
        if (val !== this.currentValue) {
          this.currentValue = val === null ? "" : val;
          if (this.Quill) {
            this.Quill.pasteHTML(this.currentValue);
          }
        };
      },
      immediate: true,
    },
  },
  mounted() {
    // 这里增加随机id，是为了解决同页面，多个富文本的情况会导致工具栏不生效
    this.toolbarId = new Date().getTime()+Math.round(Math.random()*1000);
    this.options.modules.toolbar = `#toolbar${this.toolbarId}`;
    // 延时初始化，防止dom未设置上toolbarId
    this.$nextTick(()=>{
      this.init();
    })
  },
  beforeDestroy() {
    this.Quill = null;
  },
  methods: {
    getToken() {
      return Cookies.get('token');
    },
    /** html转换 */
    htmlReverse() {
      if(!this.isHtmlReverse) {
        this.Quill.setText(this.currentValue);
      } else {
        const value = `${this.Quill.getText()}`
        const delta = this.Quill.clipboard.convert(value);
        this.Quill.setContents(delta, 'silent')
      }
      this.isHtmlReverse = !this.isHtmlReverse;
      this.updateValue();
    },
    /** 更新绑定值 */
    updateValue() {
      if(this.Quill && this.$refs.editor) {
        const html = this.$refs.editor.children[0].innerHTML;
        const text = this.Quill.getText();
        const quill = this.Quill;
        this.currentValue = html;
        this.$emit("input", html);
        this.$emit("on-change", { html, text, quill });
      }
    },
    /** 检查html转换状态 */
    chechHtmlReverseStatus(val) {
      if (this.Quill) {
        const contents = this.Quill.getContents();
        // 获取节点，并判断节点内容是否存在标签
        if(contents && contents.ops.some(v=>{ return v.insert && (typeof v.insert == 'string') && v.insert.indexOf('<p>')>=0})) this.isHtmlReverse = true;
        else this.isHtmlReverse = false;
      } else this.isHtmlReverse = false;
      this.$nextTick(()=>{
        // 传入内容检查是否存在标签
        if(val && val.indexOf('p&gt')>=0) this.isHtmlReverse = true;
      })
    },
    init() {
      const editor = this.$refs.editor;
      this.Quill = new Quill(editor, this.options);
      // 如果设置了上传地址则自定义图片上传事件
      if (this.type == 'url') {
        let toolbar = this.Quill.getModule("toolbar");
        toolbar.addHandler('image', (value) => {
          this.uploadType = 'image';
          if (value) {
            this.$refs.upload.$children[0].$refs.input.click();
          } else {
            this.quill.format('image', false);
          }
        });
      }
      this.chechHtmlReverseStatus();
      this.Quill.pasteHTML(this.currentValue);
      this.Quill.on("text-change", (delta, oldDelta, source) => {
        this.updateValue();
      });
      this.Quill.on("text-change", (delta, oldDelta, source) => {
        this.$emit("on-text-change", delta, oldDelta, source);
      });
      this.Quill.on("selection-change", (range, oldRange, source) => {
        this.$emit("on-selection-change", range, oldRange, source);
      });
      this.Quill.on("editor-change", (eventName, ...args) => {
        this.$emit("on-editor-change", eventName, ...args);
      });
      // 监听是否复制图片，将复制的图片base64进行接口上传处理
      window.addEventListener(
        'paste',
        (evt) => {
            if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
                evt.preventDefault();
                [].forEach.call(evt.clipboardData.files, (file) => {
                  if(this.handleBeforeUpload(file)) {
                    if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                        return;
                    }
                    const formData = new FormData();
                    formData.append('file', file);
                    userApi.fileUpload(formData)
                      .then((res) => {
                        // 接口上传成功，走成功方法自动处理
                        this.handleUploadSuccess(res);
                      })
                  }
                });
            }
        },
        false
      );
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message({
            type: 'info',
            message: `上传文件大小不能超过 ${this.fileSize} MB!`
          });
          return false;
        }
      }
      return true;
    },
    handleUploadSuccess(res, file) {
      console.log('handleUploadSuccess.res::', res);
      // 获取富文本组件实例
      let quill = this.Quill;
      // 如果上传成功
      if (res.state == "SUCCESS") {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', res.url);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message({
          type: 'info',
          message: '图片插入失败'
        });
      }
    },
    handleUploadError() {
      this.$message({
        type: 'info',
        message: '图片插入失败'
      });
    },
  },
};
</script>

<style>
.editor, .ql-toolbar {
  white-space: pre-wrap !important;
  line-height: normal !important;
}
.quill-img {
  display: none;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
.ql-html {
  white-space: nowrap;
  font-weight: 600;
}
.ql-html.active {
  color: #06c;
}
.readonly_toolbar {
  margin-top: 10px;
  padding: 0 !important;
  border-bottom: none !important;
}
.readonly_panel {
  background-color: rgba(229, 229, 229, 1);
  border-radius: 4px;
}
.readonly_panel .ql-container,
.readonly_panel .ql-toolbar.ql-snow {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Editor/index.vue